import { createRouter, createWebHistory } from 'vue-router'

import { isAuthenticated } from '@/libs/auth'
import { useAppStore } from '@/stores/app'

const router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        }

        if (from.path === to.path) {
            return {}
        }

        return { top: 0, behavior: 'smooth' }
    },
    routes: [
        {
            path:     '/',
            redirect: '/clients',
        },
        {
            path:      '/login',
            name:      'login',
            component: () => import('@/views/Login.vue'),
            meta:      { layout: 'Blank', requiresAuth: false },
        },
        {
            path:      '/clients',
            name:      'clients',
            component: () => import('@/views/Clients.vue'),
            meta:      { requiresAuth: true },
        },
        {
            path:      '/clients/:slug',
            name:      'client',
            component: () => import('@/views/clients/ClientDetail.vue'),
            meta:      { requiresAuth: true },
        },
        {
            path:      '/client-users',
            name:      'client-users',
            component: () => import('@/views/ClientUsers.vue'),
            meta:      { requiresAuth: true },
        },
        {
            path:      '/client-users/:id',
            name:      'client-user',
            component: () => import('@/views/client-users/ClientUserDetail.vue'),
            meta:      { requiresAuth: true },
        },
        {
            path:      '/support',
            name:      'support',
            component: () => import('@/views/Support.vue'),
            meta:      { requiresAuth: true },
        },
        {
            path:      '/admin-users',
            name:      'admin-users',
            component: () => import('@/views/AdminUsers.vue'),
            meta:      { requiresAuth: true },
        },
        {
            path:      '/audit',
            name:      'audit',
            component: () => import('@/views/Audit.vue'),
            meta:      { requiresAuth: true },
        },
    ],
})

router.beforeEach((to, from, next) => {
    const appStore = useAppStore()
    const loggedIn = isAuthenticated()

    // An authenticated admin never sees the login page.
    if (loggedIn && to.name === 'login') {
        return next({ name: 'clients' })
    }

    if (to.meta.requiresAuth && !loggedIn) {
        appStore.setLogout()

        return next({ name: 'login' })
    }

    next()
})

export default router
